/* Mogadoro Riad — theme script. No dependencies. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var R = window.Riad || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function money(cents) {
    try {
      return new Intl.NumberFormat(R.locale || 'en', { style: 'currency', currency: R.currency || 'USD', minimumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Drawers (menu, cart, filters, search) ---------- */
  var opener = null, openId = null;
  function scrim() {
    var s = $('#Scrim');
    if (!s) { s = d.createElement('div'); s.id = 'Scrim'; s.className = 'scrim'; d.body.appendChild(s); s.addEventListener('click', closeAll); }
    return s;
  }
  function openPanel(id, btn) {
    var p = d.getElementById(id); if (!p) return;
    closeAll(true);
    opener = btn || d.activeElement; openId = id;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    if (p.classList.contains('drawer')) { p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true'); }
    scrim().classList.add('is-open');
    root.classList.add('lock');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var f = p.querySelector('[data-autofocus]') || p.querySelector('button, a[href], input, select');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
  }
  function closeAll(silent) {
    $$('.drawer.is-open, .search-pop.is-open').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    var s = $('#Scrim'); if (s) s.classList.remove('is-open');
    root.classList.remove('lock');
    $$('[aria-expanded="true"][data-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && opener && opener.focus) opener.focus({ preventScroll: true });
    openId = null;
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openPanel(o.getAttribute('data-open'), o); if (o.getAttribute('data-open') === 'CartDrawer') Cart.refresh(); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openId) closeAll();
    if (e.key === 'Tab' && openId) {
      var p = d.getElementById(openId); if (!p) return;
      var f = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea', p).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  var hd = $('.hd-sticky'), lastY = window.scrollY, ticking = false;
  function setHdTop() {
    var h = hd ? hd.offsetHeight : 0;
    root.style.setProperty('--hd-h', h + 'px');
    root.style.setProperty('--hd-top', root.classList.contains('hd-hidden') ? '0px' : h + 'px');
    fitInfo();
  }
  /* Product info column: sticks at the top when it fits the screen,
     otherwise scrolls with the page and sticks by its bottom edge. */
  function fitInfo() {
    var info = d.querySelector('.info'); if (!info) return;
    if (window.innerWidth < 861) { info.style.top = ''; return; }
    var top = root.classList.contains('hd-hidden') ? 0 : (hd ? hd.offsetHeight : 0);
    info.style.top = Math.min(top + 24, window.innerHeight - info.offsetHeight - 24) + 'px';
  }
  d.addEventListener('toggle', fitInfo, true);
  function onScroll() {
    var y = window.scrollY, hidden = root.classList.contains('hd-hidden');
    if (!root.classList.contains('lock') && !(hd && hd.contains(d.activeElement) && d.activeElement !== d.body)) {
      if (y > lastY + 8 && y > 160 && !hidden) root.classList.add('hd-hidden');
      else if ((y < lastY - 8 || y < 120) && hidden) root.classList.remove('hd-hidden');
    }
    if (hidden !== root.classList.contains('hd-hidden')) setHdTop();
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', setHdTop, { passive: true });
  setHdTop();

  /* ---------- Reveal on scroll ---------- */
  var rv = $$('[data-rv]');
  if (rv.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('in'); }); }
  var hero = $('.hero'); if (hero) requestAnimationFrame(function () { hero.classList.add('is-in'); });

  /* ---------- Horizontal rails with arrows ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail]'); if (!b) return;
    var rail = d.getElementById(b.getAttribute('data-rail')); if (!rail) return;
    var dir = b.getAttribute('data-dir') === 'prev' ? -1 : 1;
    rail.scrollBy({ left: dir * rail.clientWidth * .9, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Gallery counter (phones) ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var n = d.getElementById(g.getAttribute('data-gallery')); if (!n) return;
    var items = $$('.gal__i', g);
    g.addEventListener('scroll', function () {
      var i = Math.round(g.scrollLeft / (items[0] ? items[0].offsetWidth + 10 : 1));
      n.textContent = Math.min(i + 1, items.length) + ' / ' + items.length;
    }, { passive: true });
  });

  /* ---------- Cart ---------- */
  var Cart = {
    data: null,
    refresh: function () {
      return fetch(R.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); return c; });
    },
    count: function (n) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    },
    ship: function (total) {
      var th = R.freeShipping || 0;
      return $$('[data-ship]').forEach(function (el) {
        if (!th) { el.hidden = true; return; }
        var left = th - total, pct = Math.min(100, Math.round(total / th * 100));
        var msg = el.querySelector('[data-ship-msg]'), bar = el.querySelector('i');
        if (msg) msg.textContent = left > 0 ? R.strings.shipAway.replace('[amount]', money(left)) : R.strings.shipFree;
        if (bar) bar.style.width = pct + '%';
      });
    },
    render: function (c) {
      Cart.data = c;
      Cart.count(c.item_count);
      Cart.ship(c.total_price);
      var list = $('#CartLines'); if (!list) return;
      var tot = $('#CartTotal'); if (tot) tot.textContent = money(c.total_price);
      var ft = $('#CartFoot'); if (ft) ft.hidden = c.item_count === 0;
      if (!c.items.length) { list.innerHTML = '<div class="cart-empty"><p>' + esc(R.strings.empty) + '</p></div>'; return; }
      list.innerHTML = c.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
        return '<div class="line" data-line="' + (i + 1) + '">' +
          '<a class="line__m" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="84" height="105">' : '') + '</a>' +
          '<div><a class="line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (opts ? '<div class="line__v">' + opts + '</div>' : '') +
          '<div class="qty"><button type="button" data-q="-1" aria-label="−">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-qi><button type="button" data-q="1" aria-label="+">+</button></div> ' +
          '<button type="button" class="line__rm" data-rm>' + esc(R.strings.remove) + '</button></div>' +
          '<div class="line__p">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s><br>' : '') + money(it.final_line_price) + '</div></div>';
      }).join('');
    },
    change: function (line, qty) {
      var list = d.body.classList.contains('t-cart') ? $('#CartPageLines') : $('#CartLines'); if (list) list.style.opacity = '.55';
      return fetch(R.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (list) list.style.opacity = ''; Cart.render(c); if (d.body.classList.contains('t-cart')) location.reload(); })
        .catch(function () { if (list) list.style.opacity = ''; });
    }
  };
  window.RiadCart = Cart;
  Cart.ship(R.cartTotal || 0);
  d.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-lines] [data-line]'); if (!line) return;
    var n = +line.getAttribute('data-line'), inp = line.querySelector('[data-qi]');
    if (e.target.closest('[data-rm]')) Cart.change(n, 0);
    var q = e.target.closest('[data-q]');
    if (q) Cart.change(n, Math.max(0, +inp.value + +q.getAttribute('data-q')));
  });
  d.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cart-lines] [data-qi]'); if (!inp) return;
    Cart.change(+inp.closest('[data-line]').getAttribute('data-line'), Math.max(0, +inp.value || 0));
  });

  /* Quantity steppers outside the cart */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var inp = b.parentNode.querySelector('input'); if (!inp) return;
    inp.value = Math.max(+inp.min || 1, (+inp.value || 1) + +b.getAttribute('data-step'));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form ---------- */
  $$('[data-product]').forEach(function (wrap) {
    var json = wrap.querySelector('script[type="application/json"][data-variants]'); if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = wrap.querySelector('form[data-pform]');
    var idInput = form && form.querySelector('[name="id"]');
    var btn = form && form.querySelector('[data-atc]');
    var priceEl = wrap.querySelector('[data-price]');
    var errEl = wrap.querySelector('[data-err]');

    function selected() {
      return $$('fieldset.opt', wrap).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(opts) {
      if (!opts.length) {
        var cur = idInput && +idInput.value;
        return product.variants.filter(function (v) { return v.id === cur; })[0] || product.variants[0];
      }
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var opts = selected(), v = find(opts);
      $$('fieldset.opt', wrap).forEach(function (fs, i) {
        var lab = fs.querySelector('legend span'); if (lab) lab.textContent = opts[i] || '';
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var m = find(test);
          inp.classList.toggle('is-na', !m || !m.available);
        });
      });
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = R.strings.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<span>' + money(v.price) + '</span>';
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? R.strings.add : R.strings.soldOut; }
      if (wrap.hasAttribute('data-update-url') && window.history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
      if (v.featured_media) {
        var g = wrap.querySelector('.gal'), m = g && g.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (g && m) {
          if (getComputedStyle(g).overflowX === 'auto') g.scrollTo({ left: m.offsetLeft - g.offsetLeft - parseInt(getComputedStyle(g).paddingLeft || 0, 10), behavior: reduce ? 'auto' : 'smooth' });
          else if (m !== g.firstElementChild) { g.insertBefore(m, g.firstElementChild); }
        }
      }
    }
    wrap.addEventListener('change', function (e) { if (e.target.closest('fieldset.opt')) update(); });
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (errEl) errEl.textContent = '';
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = R.strings.adding; }
      fetch(R.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || R.strings.error);
          if (btn) btn.textContent = R.strings.added;
          return Cart.refresh().then(function () {
            if (d.getElementById('CartDrawer') && wrap.getAttribute('data-drawer') !== 'false') openPanel('CartDrawer', btn);
          });
        })
        .catch(function (err) { if (errEl) errEl.textContent = err.message; })
        .finally(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label === R.strings.adding ? R.strings.add : label; } }, 900); });
    });
    update();
  });

  /* Read-more opens the description accordion */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-open-acc]'); if (!a) return;
    var t = d.getElementById(a.getAttribute('data-open-acc')); if (t) { t.open = true; }
  });

  /* ---------- Collection filters ---------- */
  var facet = d.getElementById('FacetForm');
  if (facet) {
    facet.addEventListener('submit', function () {
      $$('input', facet).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
    });
  }
})();
